import { ApiService } from 'src/app/api.service';
import { Component, OnInit, Input } from '@angular/core';
import { Router,NavigationStart } from '@angular/router';
import { CONTACT } from 'src/app/config';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.css'],
    
})
export class FooterComponent implements OnInit {
  @Input() values;
  drop: any;
  constructor(private api:ApiService, private router:Router) {
    this.drop=this.api.drop; 
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
          document.getElementById('top').click();
      }
    })
    this.api.Get(CONTACT).then(data=>{
      this.values=data['data'];
      console.log("Values", this.values);
    }).catch(d=>{
      console.log(d);
    });
   }


  ngOnInit() {
    this.api.getlogin.subscribe(data => {
      this.drop=data;
      console.log(this.drop);
     });
 //this.values={'mobile':'12345567890','landline':'0154-19953','email':'gauri@gmail','address':'patna','facebook':'FB.com','instagram':'insta.com'};
  }

}
